<template>
  <div class="edit_history_bg">
  
    <div class="edit_history_content" id="editHistoryBg"
    :style="{left:(0)+'px', height:(fullHeight)+'px'}"
    v-show="showHistoryView">
        <div class="history-title-content">
          <div class="history-title" @click.stop="onreplaceAllText">编辑历史</div>
           <a-icon class="view_close" type="close-circle" @click.stop="onClose"/>
        </div>
        <div
          class="list-content-cell"
          v-for="(item, index) in mindHistoryList"
          :key="index"
          :class="index%2 == 0 ? 'list-content-cell-dark' : 'list-content-cell-light'"
          @click="setHistoryData(index, item.fileName)">
          <div class="complie-content-icon-box" v-show="item.time > -1">
            <img src="../../../assets/img/user/currency/recentl_ycreated.svg"
              class="cell-icon"/>
            <div class="edit-time" >{{ formatTimeValue(item.time) }}</div>
            <div class="delete_label" @click.stop="onDelete(item.fileName)">删除</div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import getString from '../../../common/lang/language';
import strings from '../../../common/lang/strings';
import Template from '../../../views/template/Template.vue';
import ComplieChildMenuForm from "../ComplieRightMenuChild/ComplieChildMenuForm";
import ComplieChildMenuNodeQuickStyle from "../ComplieRightMenuChild/ComplieChildMenuNodeQuickStyle";
import EditMindmapVM from "../../../viewmodel/mindelementdata/vm/EditMindmapVM";
import dataTimeToFormats from '../../../utils/timestampToTime';
import Util from '../../../utils/Util';
import People from '../../../viewmodel/mindelementdata/mindcontent/People';
import SaveMindRouter from "../../../viewmodel/core/history/SaveMindRouter";
import HistoryIndex from "../../../viewmodel/core/history/HistoryIndex";
import HistoryIndexCell from "../../../viewmodel/core/history/HistoryIndexCell";
import UiUtil from "../../../utils/UiUtil";

export default {
  props: [
    "showHistoryView",
    "historyDataList",
    "fullHeight",
    "fullWidth",
  ],
  data() {
    return {
      strings:strings,
      mindRootId: "",
      mindSheetId: "",
      mindHistoryList: [],
    };
  },
  created(){
    // this.insertPicturesIsNeedMembers()
    this.findResultTips = getString(this.strings.Global_Text_Find_Empty)
  },
  mounted(){
    this.dragDown1();
  },
  components: {
    ComplieChildMenuForm,
    ComplieChildMenuNodeQuickStyle
  },
  methods: {
    ...mapMutations(["useShortcut", "setIsShowEditHistoryView"]),
    getString(i){
      return getString(i)
    },
    onClose(){
      this.setIsShowEditHistoryView(false);
    },

    formatTimeValue(time) {
      return this.dateFormat("YYYY-mm-dd HH:MM:SS", new Date(time))
    },

    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },

    setHistoryData(index, fileName) {
      if (fileName == "" || fileName == null) {
        return
      }
      let rootId = this.$route.query.id;
      let sheetId = this.$route.query.sheetId;
      if (rootId != this.mindRootId || sheetId != this.mindSheetId) {
        this.$message.error("当前页面与历史记录不在同一个文件，关闭重新进入文件");
        this.setListData()
        return;
      }
      EditMindmapVM.useHistoryData(this.mindRootId, this.mindSheetId, fileName)
    },

    setListData() {
      // this.mindHistoryList = []
      let rootId = this.$route.query.id;
      let sheetId = this.$route.query.sheetId;
      let that = this 
      this.mindRootId = rootId
      this.mindSheetId = sheetId
      new SaveMindRouter(this.$route.appPath).getMindHistoryIndex(rootId, sheetId).then((data) => {
          if (data == null || data.data == null) {
              that.mindHistoryList = []
              return
          }          

          let limitCount = Math.floor((that.fullHeight - 50)/40)
          let count = data.data.length

          if (count > 1) {
            data.data.sort(function (data1, data2) {
              if (data1.time > data2.time) {
                return -1;
              } else if (data1.time == data2.time) {
                return 0;
              } else {
                return 1;
              }
          })
          }
          let list = []
          if (data.data.length > limitCount) {
            for (let index = 0; index < count; index++) {
              const cell = data.data[index];
              list.push(cell)
            }
          } else {
            for (let index = 0; index < limitCount; index++) {
              if (index < count) {
                list.push(data.data[index])
              } else {
                let cell = new HistoryIndexCell()
                cell.time = -1
                list.push(cell)
              }              
            }
          }
          that.mindHistoryList = list
      })
    },

    onDelete(fileName) {
      let rootId = this.$route.query.id;
      let sheetId = this.$route.query.sheetId;
      let that = this
      let isOk = false;
      for (let index = 0; index < this.mindHistoryList.length; index++) {
        const cell = this.mindHistoryList[index];
        if (cell.fileName == fileName) {
          this.mindHistoryList.splice(index, 1);
          isOk = true;
          break
        }
      }
      if (!isOk) {
        this.$message.error("删除文件不存在");
        return
      }
      new SaveMindRouter().removeFile(rootId, sheetId, fileName).then((data) => {
          console.log("filename ", fileName, data);  
          if (data == null || !data.success) {
            this.$message.error("删除失败");
          } else {
            this.$message.success("成功删除");
          }       
      })
    },

    dragDown1(){
      document.getElementById("editHistoryBg").addEventListener("mousedown",this.dragDown);
    },
    dragDown:function(e){
      window.event ? window.event.cancelBubble = true : e.stopPropagation();
      let oDiv = document.getElementById("editHistoryBg");
      let disX = e.clientX - oDiv.offsetLeft;
      let disY = e.clientY - oDiv.offsetTop;
      document.onmousemove = (el)=>{
        let left = el.clientX - disX;
        let top = el.clientY - disY;
        oDiv.style.left = left + 'px';
        oDiv.style.top = top + 'px';
      }

      document.onmouseup = (e)=>{
        document.onmousemove = null;
        document.onmouseup = null;
      }
    },
  },
  watch: {    
    "$store.state.updateEditHistoryView": {
      handler(newval, olval) {
        if (newval) {
          this.setListData()
        } else {
        }
      },
      deep: true,
    },

    showHistoryView(newVal){
      if (newVal) {
        this.setListData()
      } else {
      }
    }
  },
};
</script>

<style lang='less' scoped>
.edit_history_bg{
  position: fixed;
  z-index: 999;
}

/* 元素菜单列表开始 */
  .edit_history_content {
    z-index: 999;
    position: absolute;
    width: 320px;
    height: 600px;
    float: right;
    overflow-y: auto;
    top: 0px;
    left: 20px;
    background-color: rgb(245, 245, 245);
    border-radius: 0 0 6px 6px;
    box-sizing: border-box;
    border-left: 1px solid #f0f0f0;
    border-right: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
    user-select: none;
    box-shadow: 0px 2px 5px #999;
    .history-title-content {
      width: 100%;
      height: 40px;
      margin-top: 10px;
      text-align: center;
      align-content: center;
      .history-title {
        width: 100%;
        height: 100%;
        font-size: 16px;
        font-weight: 700;
        color: #111111;
        text-align: center;
        align-content: center;
      }
      .view_close{
        position: absolute;
        right: 15px;
        top: 12px;
        font-size: 18px;
        color: #222222;
      }
    }
    
    .list-content-cell {
      height: 40px;
      cursor: pointer;
      .complie-content-icon-box {
        display: flex;
        align-items: center;
        height: 40px;
      }
      .cell-icon {
        width: 14px;
        height: 14px;
        margin-left: 20px;
      }
      .edit-time {
        margin-left: 10px;
        font-size: 14px;
        color: #333333;
      }
      .delete_label {
        position:absolute;
        right: 15px;
        cursor: pointer;
        margin-left: 80px;
        font-size: 12px;
        color: #888888;
      }
      .delete_label:hover {
        color: #fb5639;
        font-weight: 800;
      }
      .delete_icon {
        position: relative;
        right: -15px;
        // top: 12px;
        font-size: 18px;
        color: #222222;
      }
    }
    .list-content-cell-activate {
      cursor: pointer;
    }
    .list-content-cell-dark {
      background: #f0f0f0;
    }
    .list-content-cell-light {
      background: #ffffff;
    }
    .list-content-cell-dark:hover {
      background: #e9e9e9;
    }
    .list-content-cell-light:hover {
      background: #e9e9e9;
    }
  }
/* 元素菜单列表结束 */
</style>